import { useState } from "react"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserUpdateDialog from "@/v2-backoffice-client/user/update/UserUpdateDialog"

export type UserUpdateButtonProps = Omit<
  TooltipButtonProps,
  "content" | "onClick"
> & {
  user: UserFragment
}

function UserUpdateButton(props: UserUpdateButtonProps) {
  const { user, children, ...tooltipButtonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <TooltipButton
        variant="ghost"
        size="tiny"
        iconSrc="pencil"
        content="Edit this user's name, email, and other details."
        isSquare={!children}
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
        {...tooltipButtonProps}
      >
        {children}
      </TooltipButton>

      <UserUpdateDialog user={user} open={isOpen} onOpenChange={setIsOpen} />
    </>
  )
}

export default UserUpdateButton
